module.exports = __webpack_public_path__ + "static/media/avatar.595f9bc9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar.jpg
// module id = 731
// module chunks = 110